import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { StackColumnService } from './stack-column.service'
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ChangeFilter } from '../../change-filter'
import { ECharts } from 'echarts';
import { cloneDeep } from 'lodash'
import * as colors from '../../config/colors';
import * as backgroundColor from '../../config/backgroundColor';
import { legendPosition, axisLabelRotate, stackColumnData } from './stack-column-interface';
import { initOpts } from '../../config/initOpts';
import { ChartResizeService } from '../../service/chart-resize.service';
import { ChartDarkModeService } from '../../service/chart-dark-mode.service';
import * as _ from 'lodash';

@Component({
  selector: 'bcac-stack-column',
  templateUrl: './stack-column.component.html',
  styleUrls: ['./stack-column.component.scss']
})
export class StackColumnComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private stackColumnService: StackColumnService,
    private chartResizeService: ChartResizeService,
    private chartDarkModeService: ChartDarkModeService
  ) { }


  echartOption: any = this.stackColumnService.getStackBarChartDefaultOption();

  // 图标题
  _bcacChartTitle: { text: string, show: boolean } = { text: '图表标题', show: true }
  // 图表题文本
  @Input()
  set bcacChartTitleText(bcacChartTitleText: string) {
    this._bcacChartTitle.text = bcacChartTitleText;
    this._bcacChartFileName = bcacChartTitleText;
  }
  // 是否显示图标题
  @Input()
  set bcacChartShowTitle(bcacShowChartTitle: boolean) {
    this._bcacChartTitle.show = bcacShowChartTitle;
  }
  // 图表下载文件名
  _bcacChartFileName: string = "图表";
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }
  // 是否显示toolbox
  @Input()
  set bcacChartShowToolbox(show: boolean) {
    // this.stackColumnService.changeToolboxShow(this.echartOption, show)
    // this.updateOptions();
  }

  legendDataArr: any[] = [];
  // 更改legend位置
  _legendPosition: legendPosition = 'bottom';
  @Input()
  set bcacLegendPosition(position: legendPosition) {
    this._legendPosition = position;
    this.stackColumnService.changeLegendPosition(this.echartOption, position);
    this.updateOptions()
  };
  // 输入是否显示图例
  @Input()
  set bcacChartShowLegend(bcacLegendShow: boolean) {

    this.stackColumnService.changeLegendShow(this.echartOption, bcacLegendShow);

    this.updateOptions()
  }
  // 图加载等待
  _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  //设置tooltip单位
  @Input()
  set bcacTooltipUnit(tooltipUnit: string) {
    this.stackColumnService.changeTooltipUnit(this.echartOption, tooltipUnit);
  }
  // x轴Name
  @Input()
  set bcacXAxisName(xAxisName: string) {
    this.stackColumnService.changeXAxisName(this.echartOption, xAxisName)
    this.updateOptions();
  }
  // 输入y轴名
  @Input()
  set bcacYAxisName(yAxisName: string) {
    this.stackColumnService.changeYAxisName(this.echartOption, yAxisName)
    this.updateOptions();
  }
  // 输入y轴名距离
  @Input()
  set bcacYAxisNameGap(yAxisNameGap: number) {
    this.stackColumnService.changeYAxisNameGap(this.echartOption, yAxisNameGap);
    this.updateOptions();
  }
  // x轴label的旋转 
  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate: axisLabelRotate) {
    this.stackColumnService.changeXAxisLabelRotate(this.echartOption, xAxisLabelRotate);
    this.updateOptions();
  }
  // y轴label的旋转
  @Input()
  set bcacYAxisLabelRotate(yAxisLabelRotate: axisLabelRotate) {
    this.stackColumnService.changeYAxisLabelRotate(this.echartOption, yAxisLabelRotate);
    this.updateOptions();
  }

  _selectList: { value: string | number, optList: { label: string, value: any }[] }[] = [];
  // 数据选择区域
  @Input()
  set bcacDataSourceList(selectList: any) {
    if (Array.isArray(selectList)) {
      if (selectList.length > 0 && (selectList[0].hasOwnProperty('value') && selectList[0].hasOwnProperty('optList'))) {
        this._selectList = selectList;
      } else {
        selectList = [];
        this._selectList = selectList;
      }
    } else {
      selectList = []
      this._selectList = selectList;
    }
  }


  bcacData: any = [];


  isNotSingleData: boolean = false;

  dataSourceList: any = "";

  selectedData: string = "";

  @Input()
  set bcacChartData(data: stackColumnData) {

    let legendDataArr = [];
    if(data && data.hasOwnProperty('seriesName')) {
      data.seriesName.forEach(e => {
        legendDataArr.push({
          label: e,
          value: e,
          checked: true
        })
      })
    }
    this.legendDataArr = _.intersectionBy(legendDataArr, 'value');
    this.stackColumnService.changeChartData(this.echartOption, data)
    this.updateOptions()
  }

  singleSelectIconShow: boolean = false; //interval下拉框是否显示
  intervalData: any[] = []; //interval 数据
  intervalSelectedData: string | number = '' //当前选择的interval
  @Input() //输入interval数据
  set bcacIntervalData(value: any[]) {
    if (Array.isArray(value) && value.length > 0) {
      this.intervalData = value;
      this.singleSelectIconShow = true;
      if (value.length == 1) {
        this.axisScaleChange(value[0].value);
        this.singleSelectIconShow = false;
      }
    } else {
      this.singleSelectIconShow = false;
    }
  }

  @Input()
  set bcacDarkMode(darkMode: boolean | string) {
    this.changeChartTitleColor(darkMode);
    this.changeCardBackgroundColor(darkMode);
    this.chartDarkModeService.openDarkMode(this.echartOption, darkMode);
  }


  isSmallMode: boolean = false;
  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.isSmallMode = true;
      this.changeCardPadding("0rem");
      this.chartResizeService.openSmallMode(this.echartOption, this.isSmallMode, this._legendPosition);
      // this.chartResizeService.configSplitLine(false, this.echartOption);
      this.updateOptions();
    } else {
      this.isSmallMode = false;
    }
  }

  @Input()
  set bcacAxisSplitLine(axisSplitLineShow: boolean) {
    if (axisSplitLineShow == true) {
      this.chartResizeService.configSplitLine(true, this.echartOption)
    } else {
      this.chartResizeService.configSplitLine(false, this.echartOption)
    }
  }

  @Input()
  set bcacYAxisMin(yAxisMin: number) {
    this.stackColumnService.changeYAxisMin(this.echartOption, yAxisMin);
  }

  @Input()
  set bcacYAxisMax(yAxisMax: number) {
    this.stackColumnService.changeYAxisMax(this.echartOption, yAxisMax)
  }

  @Input()
  set bcacYAxisInterval(yAxisInterval: number) {
    this.stackColumnService.changeYAxisInterval(this.echartOption, yAxisInterval)
  }

  @Input()
  set bcacColors(chartColors: string[]) {
    if (Array.isArray(chartColors)) {
      this.commonService.changeChartColors(this.echartOption, chartColors)
    }
  }

  @Input() 
  set bcacYAxisMinInterval(yAxisMinInterval: number) {
    this.stackColumnService.changeYAxisMinInterval(this.echartOption, yAxisMinInterval)
  }

  @Output() bcacGetChartInstance: EventEmitter<ECharts> = new EventEmitter<ECharts>();

  @Output() bcacDataSourceSelectEmit: EventEmitter<any> = new EventEmitter<any>();

  initOpts;
  ngOnInit() {

    this.initOpts = initOpts;
    fromEvent(window, "resize").pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdapt(this.chartInstance, this.echartOption)
    })
  }

  // 更新配置
  updateOptions() {
    if (this.chartInstance) {
      this.chartInstance.setOption(this.echartOption, true);
    }
  }

  chartInstance: ECharts;
  onOptionInit($event) {
    this.chartInstance = $event;

    this.bcacGetChartInstance.emit($event);
  }

  selectedDataChange($event) {
    this.bcacData.forEach(element => {
      if (element.name === $event) {
        this.stackColumnService.changeChartData(this.echartOption, element.data);
        this.updateOptions();
        return;
      }
    })
  }

  selectedModelChange($event) {
    this.bcacDataSourceSelectEmit.emit($event)
  }

  // 坐标轴interval改变
  axisScaleChange(interval: any) {
    this.stackColumnService.setInterval(this.echartOption, interval)
    this.updateOptions();
  }

  // 图例改变
  legendChange(e) {
    this.stackColumnService.topLegendChange(e, this.chartInstance);
  }
  chartTitleColor = '';
  // 更改chartTitle颜色  
  changeChartTitleColor(darkMode: boolean | string) {
    if (!darkMode) {
      this.chartTitleColor = ''
    } else {
      this.chartTitleColor = colors.darkModeTextColor;
    }
  }
  // 更改card背景色
  cardBgColor = "#fff";
  changeCardBackgroundColor(darkMode: boolean | string) {
    if (typeof (darkMode) === 'string') {
      this.cardBgColor = darkMode;
    } else if (darkMode) {
      this.cardBgColor = backgroundColor.darkModeBGColor;
    }
  }
  cardPadding = "1rem";
  changeCardPadding(cardPadding: string) {
    this.cardPadding = cardPadding;
  }
}
